import moment from "moment";
export const getISODateTime = (date) => {
  return moment({
    date: date.substr(0, 2),
    month: date.substr(3, 2) - 1,
    year: date.substr(6),
    hour: moment().hour(),
    minute: moment().minute(),
    second: moment().second(),
    millisecond: moment().millisecond(),
  }).toISOString();
};

export const getISODateNoTime = (date) => {
  return (
    moment({
      date: date.substr(0, 2),
      month: date.substr(3, 2) - 1,
      year: date.substr(6),
      hour: moment().hour(),
      minute: moment().minute(),
      second: moment().second(),
      millisecond: moment().millisecond(),
    })
      .toISOString()
      .substring(0, 10) + "T00:00:00.000Z"
  );
};
